import { Box, Button, Modal, Typography } from "@mui/material";
import WbSunnyOutlined from "@mui/icons-material/WbSunnyOutlined";
import { useAuth } from "../../context/authContext";
import { goalEffortLine, greeting, queueSummary, todayLabel } from "../../pages/CRM/dayPlan";
import { useDayCoach } from "./DayCoachContext";

const INK = "#0f172a";
const MUTED = "#64748b";

export default function DayBriefModal() {
  const coach = useDayCoach();
  const { user } = useAuth();
  if (!coach?.enabled) return null;

  const summary = queueSummary(coach.remaining);
  const first = user?.name?.split(" ")[0] || "";
  const highlights = coach.remaining.filter((item) => item.bucket === "overdue" || item.bucket === "urgent").slice(0, 3);
  const empty = !coach.loading && summary.total === 0;

  return (
    <Modal open={coach.briefOpen} onClose={coach.closeBrief}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "calc(100% - 28px)", sm: 460 },
          outline: "none",
        }}
      >
        <Box
          sx={{
            bgcolor: "#fff",
            borderRadius: "22px",
            overflow: "hidden",
            boxShadow: "0 24px 60px rgba(15, 23, 42, 0.18)",
          }}
        >
          <Box
            sx={{
              px: 2.75,
              pt: 2.75,
              pb: 2.25,
              background: "linear-gradient(180deg, #fff7ed 0%, #ffffff 72%)",
            }}
          >
            <Box
              sx={{
                width: 42,
                height: 42,
                borderRadius: "14px",
                display: "grid",
                placeItems: "center",
                bgcolor: "#ffedd5",
                color: "#c2410c",
                mb: 1.5,
              }}
            >
              <WbSunnyOutlined />
            </Box>
            <Typography sx={{ fontSize: "1.35rem", fontWeight: 750, color: INK, letterSpacing: "-0.03em", lineHeight: 1.15 }}>
              {greeting()}{first ? `, ${first}` : ""}
            </Typography>
            <Typography sx={{ fontSize: "0.86rem", color: MUTED, mt: 0.6 }}>{todayLabel()}</Typography>
          </Box>

          <Box sx={{ px: 2.75, pb: 2.5 }}>
            {coach.loading ? (
              <Typography sx={{ fontSize: "0.9rem", color: MUTED, py: 2 }}>Revisando tu día…</Typography>
            ) : empty && coach.doneCount > 0 ? (
              <Typography sx={{ fontSize: "0.95rem", color: "#334155", lineHeight: 1.5, mb: 2 }}>
                Día bien cerrado. Sumaste {coach.doneCount} {coach.doneCount === 1 ? "contacto" : "contactos"}. Eso es avance de verdad.
              </Typography>
            ) : empty ? (
              <Typography sx={{ fontSize: "0.95rem", color: "#334155", lineHeight: 1.5, mb: 2 }}>
                Hoy tienes el día despejado. Buen momento para dejar prospectos listos y abrir mañana con ventaja.
              </Typography>
            ) : (
              <>
                <Typography sx={{ fontSize: "0.95rem", color: "#334155", lineHeight: 1.5, mb: 1.5 }}>
                  {coach.goal ? goalEffortLine(coach.goal.done, coach.goal.target) : "Un paso más y la meta de hoy queda hecha."} Cada contacto cuenta.
                </Typography>
                {highlights.length > 0 && (
                  <Box sx={{ borderRadius: "14px", bgcolor: "#fff1f2", px: 1.5, py: 1.15, mb: 0.5 }}>
                    <Typography sx={{ fontSize: "0.68rem", fontWeight: 800, letterSpacing: "0.06em", textTransform: "uppercase", color: "#be123c" }}>
                      Empieza por aquí
                    </Typography>
                    {highlights.map((item) => (
                      <Typography key={item.id} sx={{ fontSize: "0.84rem", color: "#881337", mt: 0.35, fontWeight: 650 }}>
                        {item.lead.companyName}
                        <Typography component="span" sx={{ fontWeight: 500, color: "#9f1239" }}>
                          {" "}· {item.verb}
                        </Typography>
                      </Typography>
                    ))}
                  </Box>
                )}
              </>
            )}

            <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
              <Button
                onClick={coach.closeBrief}
                sx={{
                  flex: empty ? 1 : undefined,
                  textTransform: "none",
                  color: MUTED,
                  fontWeight: 650,
                  borderRadius: "12px",
                }}
              >
                {empty ? "Cerrar" : "Ahora no"}
              </Button>
              {!empty && (
                <Button
                  variant="contained"
                  onClick={coach.startGuide}
                  sx={{
                    flex: 1,
                    textTransform: "none",
                    fontWeight: 750,
                    borderRadius: "12px",
                    boxShadow: "none",
                    bgcolor: "#0f172a",
                    py: 1.1,
                    "&:hover": { bgcolor: "#1e293b", boxShadow: "none" },
                  }}
                >
                  Empezar el día
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
